import React from 'react';
import { useTranslation } from 'react-i18next';
import './AlreadyVoted.css';

// Map animal names to image files
const ANIMAL_IMAGES = {
  'Arara Azul': '/assets/animals/arara.jpg',
  'Boto Cor-de-Rosa': '/assets/animals/boto.jpg',
  'Jacaré do Pantanal': '/assets/animals/jacare.jpg',
  'Capivara': '/assets/animals/capivara.jpg',
  'Suçuarana': '/assets/animals/puma.jpg',
  'Tamanduá-Bandeira': '/assets/animals/tamandua.jpg',
  'Tatu': '/assets/animals/tatu.jpg',
  'Teiú': '/assets/animals/teiu.jpg',
  'Tucano': '/assets/animals/tucano.jpg'
};

function AlreadyVoted({ votedAnimal }) {
  const { t } = useTranslation();

  // Normalize votedAnimal to array
  const votedAnimals = Array.isArray(votedAnimal) ? votedAnimal : [votedAnimal];
  const isMultiple = votedAnimals.length > 1;

  return (
    <div className="already-voted">
      <div className="voted-container">
        <div className="voted-icon">
          <span className="checkmark">✓</span>
        </div>
        
        <h1 className="voted-title">{t('alreadyVoted.title')}</h1>
        
        <div className="voted-animal-display">
          {votedAnimals.map((animal, index) => (
            <div key={index} className="voted-animal-item">
              <div className="voted-animal-image">
                <img 
                  src={ANIMAL_IMAGES[animal] || '/assets/animals/arara.png'} 
                  alt={t(`animals.${animal}`) || animal}
                  className="animal-img"
                />
              </div>
              <h2 className="voted-animal-name">
                {t(`animals.${animal}`) || animal}
              </h2>
            </div>
          ))}
        </div>
        
        <p className="voted-message">
          {isMultiple ? t('alreadyVoted.messageMulti') : t('alreadyVoted.message')}
        </p>
        
        <p className="voted-thanks">{t('alreadyVoted.thanks')}</p>
        
        <p className="voted-note">{t('alreadyVoted.note')}</p>
      </div>
    </div>
  );
}

export default AlreadyVoted;
